export const actionAddUser = data => ({
  type: 'ACTION_ADD_USER',
  payload: data
});

export const actionDeleteUser = data => ({
  type: 'ACTION_DELETE_USER',
  payload: data
});
